<section class="exemplo">    
    <div class="fundo"> 
        <h1>Eu Sou <label>{{namePerson}}</label><span>.</span></h1> 
        <p> <span> {{professionSecundaryPerson}} </span> <br /> <span>{{professionPerson}}</span></p>
        <div class="container">
                <div class="circulo lime"><span> {{abreviationPerson}}{{abreviationPerson}} </span></div>
            <p>{{descriptionPerson}}</p>
        </div>
    </div>
</section>  